module.exports = __webpack_public_path__ + "img/FF_Info_Game_2.238cb3ea.png";